<template>
  <div v-show="bindPhonePop.isShow" class="bind-phone-pop">
    <qc-dialog
      :title="title"
      :width="400"
      type="custom"
      :show="true"
      :default-cancel="false"
      @close="onClose"
    >
      <div class="form">
        <div class="form-item">
          <el-input class="phone-input" v-model="form.phone" placeholder="请输入手机号" @input="onPhoneInput" />
          <sms-code-button :phone="form.phone" countdownTextHeight="40">
            <template #button>
              <el-button type="primary" plain>获取验证码</el-button>
            </template>
          </sms-code-button>
        </div>

        <div class="form-item">
          <el-input id="code" v-model="form.code" placeholder="请输入验证码" />
        </div>

        <div class="form-item">
          <el-button type="primary" :loading="isLoading" class="confirm-btn" @click="onConfirmBindPhone">
            确定绑定
          </el-button>
        </div>
      </div>
    </qc-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Validator } from '@/lib/helper';
import SmsCodeButton from '@/components/sms-code-button';
import commonApi from '@/apis/common';
import userCenterApi from '@/apis/userCenter/index';

export default {
  name: 'BindPhonePop',
  components: {
    SmsCodeButton,
  },
  data() {
    return {
      title: '绑定手机号',
      isPhoneValid: false,
      changePhone: false,
      changeText: '修改',
      form: {
        phone: '',
        code: '',
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      bindPhonePop: state => state.common.bindPhonePop,
    }),
  },
  methods: {
    onChangePhone() {
      this.changePhone = !this.changePhone;
      this.changeText = this.changeText === '修改' ? '取消' : '修改';
    },
    onPhoneInput() {
      const isValid = Validator.checkPhone(this.form.phone);
      this.isPhoneValid = isValid;
    },

    async onConfirmBindPhone() {
      if (!this.form.phone.trim()) {
        this.$message.error('请输入手机号');
        return;
      }

      if (!this.isPhoneValid) {
        this.$message.error('请输入正确的手机号');
        return;
      }

      if (!this.form.code.trim()) {
        this.$message.error('请输入验证码');
        return;
      }

      this.reqVerifySmscode();
    },

    reqVerifySmscode() {
      if (this.isLoading) return;
      this.isLoading = true;

      const reqData = {
        phone_number: this.form.phone,
        code: this.form.code,
      };
      commonApi.verifySmsCode(reqData, this)
        .then((res) => {
          this.isLoading = false;
          if (Number(res?.head?.code) === 0) {
            // 验证成功之后开始绑定
            this.reqBindPhone();
          };
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    reqBindPhone() {
      this.isLoading = true;
      const reqData = {
        phone: this.form.phone,
        smscode: this.form.code,
      };
      userCenterApi.bindPhone(reqData, false)
        .then((res) => {
          const code = Number(res?.head?.code);
          if (code !== 0) {
            const errorMsg = `[${code}] 手机号绑定失败：${res?.head?.msg}`;
            this.$message.error(errorMsg);
            return;
          };

          this.$message.success('绑定手机号成功');
          this.form.phone = '';
          this.form.code = '';
          this.$store.dispatch('userCenter/fetchCpProfile');
          this.$store.commit('common/HIDE_BIND_PHONE_POP');
        })
        .catch((err) => {
          const errorMsg = `[${err?.code}] 手机号绑定失败：${err?.message}`;
          this.$message.error(errorMsg);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onClose() {
      this.$store.commit('common/HIDE_BIND_PHONE_POP');
    },
    onCancel() {
      this.$store.commit('common/HIDE_BIND_PHONE_POP');
    },
    onConfirm() {
      this.$store.commit('common/HIDE_BIND_PHONE_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@radius: 4px;
@inputH: 40px;

.bind-phone-pop {
  position: relative;
  z-index: 3;

  .phone-input {
    margin-right: 10px;
  }
  .confirm-btn {
    height: @inputH;
    border-radius: @radius;
    width: 100%;
    margin-top: 20px;
  }
  .tc-15-rich-dialog {
    position: relative;
  }
  .cancel-btn {
    margin-right: 10px;
  }

  header {
    padding: 0 20px;
  }
  .form {
    padding: 20px 0;
    min-height: 240px;
  }
  .form-item {
    display: flex;
    margin-bottom: 10px;
  }
  .form-item {
    display: flex;
    margin-bottom: 10px;
  }
  .form-btn {
    margin-top: 20px;

    .confirm-btn {
      width: 100%;
    }
  }
}
</style>

